module.exports = __webpack_public_path__ + "media/views/about/images/handshake-22a6dba923ba6bb4feac4cdc62ca9720.svg";